import React from 'react';

export const AppleIcon = ({ size }) => {
  const makePath = size => {
    switch (size) {
      case 33:
        return (
          <path
            d="M20.6251 5.5L20.4134 5.57056C18.0764 6.34956 16.5001 8.53659 16.5001 11V7.50669C16.5001 5.54038 15.1122 3.84742 13.1841 3.4618L9.62511 2.75V3.49331C9.62511 5.45962 11.013 7.15258 12.9411 7.5382L16.5001 8.25M21.7822 9.27946C23.2219 9.18089 24.6304 9.7307 25.6225 10.7786C26.5526 11.761 27.0774 13.0538 27.1 14.3991L27.0963 14.7103L27.0609 15.5787C26.9852 17.4341 26.6867 19.2727 26.1724 21.0553L25.9695 21.721L25.4647 23.2922C24.843 25.2268 23.2992 26.7251 21.3468 27.2885C20.5178 27.5277 19.3883 27.4762 17.9582 27.1339L17.5607 27.0334C16.8655 26.8484 16.1341 26.8484 15.4389 27.0334C13.8195 27.4644 12.5577 27.5495 11.6535 27.2885C9.70107 26.7251 8.15721 25.2268 7.53557 23.2922L7.03073 21.721C6.39166 19.7322 6.02454 17.666 5.93935 15.5787L5.90391 14.7103C5.8445 13.2546 6.37603 11.8366 7.37773 10.7786C8.36987 9.7307 9.77831 9.18089 11.218 9.27946L12.0679 9.33765C13.2899 9.42132 14.7676 10.3181 16.501 12.028C18.1055 10.3985 19.4754 9.51208 20.6109 9.3689L20.9324 9.33765L21.7822 9.27946Z"
            stroke="#8BAA36"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
        );
      case 49:
        return (
          <path
            d="M30.6252 8.16659L30.3109 8.27136C26.8408 9.42805 24.5002 12.6755 24.5002 16.3333V11.1462C24.5002 8.22655 22.4394 5.71276 19.5764 5.14016L14.2919 4.08325V5.18695C14.2919 8.10662 16.3527 10.6204 19.2157 11.193L24.5002 12.2499M32.3434 13.7785C34.4811 13.6321 36.5724 14.4485 38.0456 16.0045C39.4267 17.4632 40.2059 19.3829 40.2395 21.3803L40.234 21.8425L40.1813 23.1319C40.0689 25.8869 39.6257 28.617 38.8621 31.2638L38.5608 32.2524L37.8112 34.5852C36.8881 37.4579 34.5958 39.6826 31.6968 40.5192C30.4659 40.8744 28.7887 40.7979 26.6652 40.2897L26.075 40.1404C25.0428 39.8657 23.9567 39.8657 22.9244 40.1405C20.5199 40.7805 18.6463 40.9067 17.3036 40.5192C14.4046 39.6826 12.1123 37.4579 11.1892 34.5852L10.4396 32.2524C9.49068 29.2992 8.94556 26.2312 8.81907 23.1319L8.76644 21.8425C8.67822 19.6809 9.46746 17.5755 10.9548 16.0045C12.428 14.4485 14.5193 13.6321 16.657 13.7785L17.919 13.8649C19.7334 13.9892 21.9276 15.3207 24.5016 17.8597C26.8839 15.44 28.9181 14.1239 30.6041 13.9113L31.0814 13.8649L32.3434 13.7785Z"
            stroke="#8BAA36"
            strokeWidth="2"
            strokeLinecap="round"
          />
        );
      case 56:
        return (
          <path
            d="M34.9998 9.33341L34.6406 9.45315C30.6748 10.7751 27.9998 14.4864 27.9998 18.6667V12.7387C27.9998 9.40194 25.6446 6.52904 22.3726 5.87464L16.3331 4.66675V5.92812C16.3331 9.26489 18.6884 12.1378 21.9603 12.7922L27.9998 14.0001M36.9634 15.747C39.4065 15.5798 41.7966 16.5128 43.4802 18.291C45.0587 19.9582 45.9491 22.152 45.9876 24.4349L45.9813 24.963L45.9211 26.4367C45.7926 29.5852 45.2861 32.7054 44.4135 35.7303L44.0691 36.86L43.2124 39.5262C42.1575 42.8092 39.5376 45.3517 36.2245 46.3079C34.8178 46.7138 32.901 46.6264 30.4741 46.0456L29.7996 45.8749C28.6199 45.561 27.3786 45.561 26.1989 45.875C23.4509 46.6064 21.3097 46.7507 19.7752 46.3079C16.462 45.3517 13.8422 42.8092 12.7873 39.5262L11.9306 36.86C10.8461 33.485 10.2231 29.9787 10.0785 26.4367L10.0184 24.963C9.91755 22.4927 10.8195 20.0864 12.5194 18.291C14.203 16.5128 16.5931 15.5798 19.0362 15.747L20.4784 15.8458C22.5521 15.9878 25.0597 17.5096 28.0014 20.4112C30.7241 17.6459 33.0489 16.1418 34.9757 15.8988L35.5212 15.8458L36.9634 15.747Z"
            stroke="#8BAA36"
            strokeWidth="2"
            strokeLinecap="round"
          />
        );
      case 60:
        return (
          <path
            d="M37.4996 10L37.1147 10.1283C32.8656 11.5447 29.9996 15.5211 29.9996 20V13.6485C29.9996 10.0734 27.4761 6.99531 23.9705 6.29417L17.4996 5V6.35147C17.4996 9.92658 20.023 13.0047 23.5287 13.7058L29.9996 15M39.6034 16.8717C42.2211 16.6925 44.7818 17.6922 46.5857 19.5974C48.2769 21.3837 49.231 23.7342 49.2722 26.1801L49.2654 26.746L49.201 28.3249C49.0633 31.6983 48.5206 35.0414 47.5856 38.2823L47.2166 39.4928L46.2988 42.3494C45.1685 45.8669 42.3615 48.5911 38.8117 49.6155C37.3045 50.0504 35.2508 49.9567 32.6506 49.3344L31.9279 49.1516C30.664 48.8153 29.334 48.8153 28.0701 49.1517C25.1258 49.9354 22.8316 50.0899 21.1875 49.6155C17.6377 48.5911 14.8307 45.8669 13.7004 42.3494L12.7825 39.4928C11.6206 35.8767 10.9531 32.12 10.7982 28.3249L10.7338 26.746C10.6257 24.0992 11.5922 21.5211 13.4134 19.5974C15.2173 17.6922 17.7781 16.6925 20.3957 16.8717L21.941 16.9776C24.1627 17.1297 26.8495 18.7602 30.0012 21.8691C32.9184 18.9063 35.4093 17.2947 37.4737 17.0344L38.0582 16.9776L39.6034 16.8717Z"
            stroke="#8BAA36"
            strokeWidth="2"
            strokeLinecap="round"
          />
        );
      default:
        break;
    }
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {makePath(size)}
    </svg>
  );
};

export const FishIcon = ({ size }) => {
  const makePath = size => {
    switch (size) {
      case 33:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.1472 12.5038C17.3329 8.64557 25.4751 10.5323 29.3333 16.718L29.0285 17.1845C28.2951 18.2568 27.4067 19.2159 26.3915 20.03C21.2025 24.1913 13.832 23.7958 9.11613 19.375C8.36003 21.3245 6.39802 22.6398 4.20252 22.4806L4 22.4616V22.118C4 20.0584 4.9017 18.177 6.36275 16.8897C5.00451 15.8359 4.11 14.2229 4.00947 12.4094L4 12.0671V10.9744L4.27637 10.9856C6.35258 11.1201 8.13023 12.3929 8.96938 14.2033C9.63115 13.5642 10.3616 12.9938 11.1472 12.5038ZM18.7163 22.9204L18.8917 22.9118C17.9197 23.8798 16.7282 24.615 15.3721 25.0132C14.3185 25.3225 13.258 25.4012 12.2354 25.2775C12.7348 24.2633 13.1221 23.179 13.3847 22.0493C15.0844 22.7046 16.903 22.9991 18.7163 22.9204ZM20.0177 10.4516L20.1557 10.6593C17.5429 10.253 14.7979 10.6258 12.2944 11.8641C11.5293 10.2476 10.5031 8.8384 9.29437 7.68684C9.81588 7.39691 10.3743 7.1601 10.9639 6.98701C14.4436 5.96538 17.9977 7.45938 20.0177 10.4516Z"
              stroke="#8BAA36"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M23.333 15.4668V15.3335V15.4668Z"
              stroke="#8BAA36"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      case 49:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.0691 19.1463C26.5409 13.2383 39.0087 16.1274 44.9167 25.5993L44.45 26.3135C43.3268 27.9555 41.9665 29.4241 40.412 30.6707C32.4663 37.0428 21.1802 36.4371 13.9591 29.6677C12.8013 32.6529 9.79696 34.667 6.43511 34.4231L6.125 34.3941V33.868C6.125 30.7142 7.50573 27.8334 9.74296 25.8622C7.66315 24.2485 6.29344 21.7787 6.13949 19.0017L6.125 18.4776V16.8044L6.54819 16.8214C9.72739 17.0275 12.4494 18.9765 13.7344 21.7486C14.7477 20.77 15.8662 19.8965 17.0691 19.1463ZM28.6594 35.0966L28.928 35.0835C27.4396 36.5657 25.6151 37.6915 23.5385 38.3012C21.9252 38.7749 20.3014 38.8954 18.7355 38.706C19.5001 37.1529 20.0931 35.4927 20.4953 33.7628C23.098 34.7662 25.8827 35.2171 28.6594 35.0966ZM30.6521 16.0038L30.8634 16.3219C26.8625 15.6998 22.6593 16.2705 18.8257 18.1668C17.6542 15.6914 16.0828 13.5336 14.232 11.7703C15.0306 11.3263 15.8857 10.9637 16.7885 10.6987C22.1168 9.13429 27.5589 11.422 30.6521 16.0038Z"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.7295 23.6832V23.479V23.6832Z"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      case 56:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.5075 21.8816C30.3325 15.1297 44.5814 18.4315 51.3333 29.2565L50.8 30.0727C49.5164 31.9494 47.9617 33.6277 46.1852 35.0524C37.1043 42.3348 24.2059 41.6426 15.9532 33.9062C14.6301 37.3177 11.1965 39.6197 7.35442 39.3409L7 39.3078V38.7064C7 35.1021 8.57797 31.8097 11.1348 29.5569C8.75789 27.7127 7.1925 24.8901 7.01656 21.7164L7 21.1174V19.2052L7.48365 19.2247C11.117 19.4602 14.2279 21.6876 15.6964 24.8557C16.8545 23.7373 18.1328 22.7391 19.5075 21.8816ZM32.7536 40.1106L33.0605 40.0956C31.3595 41.7896 29.2744 43.0762 26.9012 43.773C25.0573 44.3143 23.2016 44.452 21.412 44.2356C22.2858 42.4606 22.9636 40.5632 23.4232 38.5863C26.3977 39.733 29.5803 40.2483 32.7536 40.1106ZM35.0309 18.2902L35.2725 18.6538C30.7 17.9428 25.8964 18.5951 21.5151 20.7622C20.1762 17.9332 18.3804 15.4671 16.2651 13.4519C17.1778 12.9445 18.1551 12.5301 19.1869 12.2272C25.2764 10.4394 31.4959 13.0539 35.0309 18.2902Z"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M40.833 27.0668V26.8335V27.0668Z"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      case 60:
        return (
          <>
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M20.9009 23.4445C32.4991 16.2103 47.7658 19.748 55 31.3462L54.4285 32.2207C53.0532 34.2314 51.3875 36.0296 49.4841 37.556C39.7546 45.3586 25.9349 44.617 17.0927 36.3279C15.6751 39.9832 11.9963 42.4495 7.87973 42.1509L7.5 42.1154V41.4711C7.5 37.6093 9.19069 34.0818 11.9302 31.6681C9.38345 29.6921 7.70625 26.6679 7.51775 23.2675L7.5 22.6257V20.5769L8.01819 20.5978C11.9111 20.8501 15.2442 23.2366 16.8176 26.631C18.0584 25.4327 19.4281 24.3632 20.9009 23.4445ZM35.0931 42.9755L35.422 42.9595C33.5995 44.7745 31.3654 46.153 28.8227 46.8995C26.8471 47.4795 24.8588 47.6271 22.9414 47.3952C23.8777 45.4935 24.6038 43.4605 25.0963 41.3423C28.2833 42.571 31.6932 43.1231 35.0931 42.9755ZM37.5331 19.5966L37.792 19.9861C32.8929 19.2243 27.7461 19.9232 23.0519 22.2451C21.6174 19.2141 19.6933 16.5718 17.4269 14.4127C18.4048 13.869 19.4519 13.425 20.5573 13.1005C27.0818 11.1849 33.7456 13.9862 37.5331 19.5966Z"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M43.75 29V28.75V29Z"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      default:
        break;
    }
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {makePath(size)}
    </svg>
  );
};

export const PorkIcon = ({ size }) => {
  const makePath = size => {
    switch (size) {
      case 33:
        return (
          <>
            <g clipPath="url(#clip0_2212_1162)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.94402 29.4589C9.13856 30.2644 7.83266 30.2644 7.02721 29.4589C6.39246 28.8242 6.25793 27.8786 6.62361 27.1122L6.45716 26.9457C5.69067 27.3114 4.74513 27.1769 4.11039 26.5421C3.30493 25.7366 3.30493 24.4307 4.11039 23.6253C4.91585 22.8198 6.22175 22.8198 7.02721 23.6253C7.19792 23.796 7.33245 23.9892 7.4308 24.1953L9.94143 21.6837C10.2045 22.0529 10.5017 22.4052 10.8329 22.7364C11.1644 23.068 11.5172 23.3654 11.8867 23.6287L9.37528 26.1391C9.58093 26.2374 9.77367 26.3718 9.94402 26.5421C10.7495 27.3476 10.7495 28.6535 9.94402 29.4589ZM17.0508 4.85322L17.0692 4.8328C18.6802 3.22189 22.5979 4.52779 25.8197 7.74962C29.0415 10.9714 30.3474 14.8892 28.7365 16.5001L22.5001 22.7364C19.2783 25.9583 14.0547 25.9583 10.8329 22.7364C7.61106 19.5146 7.61106 14.291 10.8329 11.0692L17.0508 4.85322ZM17.0692 4.8328C15.4583 6.44372 16.7642 10.3614 19.9861 13.5833C23.2079 16.8051 27.1256 18.111 28.7365 16.5001C30.3474 14.8892 29.0415 10.9714 25.8197 7.74962C22.5979 4.52779 18.6802 3.22189 17.0692 4.8328ZM20.9583 8.72189C20.4214 9.25886 20.8567 10.5648 21.9306 11.6387C23.0045 12.7127 24.3104 13.148 24.8474 12.611C25.3844 12.074 24.9491 10.7681 23.8751 9.69416C22.8012 8.62022 21.4953 8.18492 20.9583 8.72189Z"
                stroke="#8BAA36"
                strokeWidth="1.3"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1162">
                <rect width="33" height="33" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      case 49:
        return (
          <>
            <g clipPath="url(#clip0_2212_1084)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14.766 43.7422C13.57 44.9381 11.6309 44.9381 10.4349 43.7422C9.49243 42.7997 9.29267 41.3957 9.83565 40.2576L9.58849 40.0104C8.45037 40.5534 7.0464 40.3536 6.1039 39.4111C4.90792 38.2151 4.90792 36.2761 6.1039 35.0801C7.29988 33.8841 9.23895 33.8841 10.4349 35.0801C10.6884 35.3336 10.8882 35.6204 11.0342 35.9265L14.7621 32.1971C15.1528 32.7453 15.594 33.2685 16.0858 33.7603C16.5781 34.2526 17.1018 34.6942 17.6506 35.0851L13.9215 38.8128C14.2268 38.9587 14.513 39.1582 14.766 39.4111C15.9619 40.6071 15.9619 42.5462 14.766 43.7422ZM25.3184 7.20642L25.3458 7.1761C27.7378 4.78414 33.555 6.72321 38.3389 11.5071C43.1228 16.2911 45.0619 22.1083 42.6699 24.5002L33.4099 33.7603C28.626 38.5442 20.8697 38.5442 16.0858 33.7603C11.3019 28.9763 11.3019 21.2201 16.0858 16.4361L25.3184 7.20642ZM25.3458 7.1761C22.9539 9.56806 24.8929 15.3853 29.6769 20.1692C34.4608 24.9531 40.278 26.8922 42.6699 24.5002C45.0619 22.1083 43.1228 16.2911 38.3389 11.5071C33.555 6.72321 27.7378 4.78414 25.3458 7.1761ZM31.1205 12.9508C30.3232 13.7481 30.9696 15.6872 32.5642 17.2818C34.1589 18.8765 36.0979 19.5228 36.8952 18.7255C37.6926 17.9282 37.0462 15.9891 35.4516 14.3945C33.8569 12.7998 31.9179 12.1535 31.1205 12.9508Z"
                stroke="#8BAA36"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1084">
                <rect width="49" height="49" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      case 56:
        return (
          <>
            <g clipPath="url(#clip0_2212_1110)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.8748 49.9908C15.508 51.3577 13.2919 51.3577 11.9251 49.9908C10.8479 48.9137 10.6196 47.3091 11.2402 46.0084L10.9577 45.726C9.65702 46.3465 8.05247 46.1182 6.97533 45.0411C5.60849 43.6742 5.60849 41.4582 6.97533 40.0913C8.34216 38.7245 10.5582 38.7245 11.9251 40.0913C12.2148 40.381 12.4431 40.7089 12.61 41.0587L16.8704 36.7965C17.3169 37.423 17.8212 38.0209 18.3832 38.583C18.9458 39.1456 19.5444 39.6503 20.1715 40.0971L15.9097 44.3573C16.2587 44.5241 16.5857 44.752 16.8748 45.0411C18.2417 46.4079 18.2417 48.624 16.8748 49.9908ZM28.9348 8.2357L28.9661 8.20105C31.6998 5.46738 38.348 7.68346 43.8153 13.1508C49.2827 18.6181 51.4988 25.2664 48.7651 28L38.1822 38.583C32.7148 44.0503 23.8505 44.0503 18.3832 38.583C12.9159 33.1156 12.9159 24.2513 18.3832 18.784L28.9348 8.2357ZM28.9661 8.20105C26.2324 10.9347 28.4485 17.583 33.9159 23.0503C39.3832 28.5176 46.0314 30.7337 48.7651 28C51.4988 25.2664 49.2827 18.6181 43.8153 13.1508C38.348 7.68346 31.6998 5.46738 28.9661 8.20105ZM35.5658 14.8007C34.6545 15.7119 35.3932 17.928 37.2157 19.7505C39.0381 21.5729 41.2542 22.3116 42.1654 21.4004C43.0767 20.4892 42.338 18.2731 40.5155 16.4506C38.6931 14.6282 36.477 13.8895 35.5658 14.8007Z"
                stroke="#8BAA36"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1110">
                <rect width="56" height="56" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      case 60:
        return (
          <>
            <g clipPath="url(#clip0_2212_1031)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.0803 53.5614C16.6158 55.0259 14.2415 55.0259 12.777 53.5614C11.6229 52.4073 11.3783 50.6881 12.0432 49.2945L11.7406 48.9919C10.3469 49.6568 8.62778 49.4122 7.4737 48.2581C6.00924 46.7936 6.00924 44.4193 7.4737 42.9548C8.93817 41.4903 11.3125 41.4903 12.777 42.9548C13.0874 43.2652 13.332 43.6164 13.5108 43.9912L18.0756 39.4246C18.554 40.0958 19.0942 40.7365 19.6964 41.3387C20.2992 41.9415 20.9406 42.4822 21.6125 42.961L17.0462 47.5254C17.4201 47.7041 17.7706 47.9484 18.0803 48.2581C19.5448 49.7226 19.5448 52.0969 18.0803 53.5614ZM31.0017 8.82375L31.0353 8.78663C33.9642 5.8577 41.0873 8.23207 46.9452 14.0899C52.803 19.9478 55.1774 27.0709 52.2485 29.9998L40.9096 41.3387C35.0518 47.1965 25.5543 47.1965 19.6964 41.3387C13.8386 35.4808 13.8386 25.9833 19.6964 20.1255L31.0017 8.82375ZM31.0353 8.78663C28.1063 11.7156 30.4807 18.8387 36.3386 24.6965C42.1964 30.5544 49.3195 32.9288 52.2485 29.9998C55.1774 27.0709 52.803 19.9478 46.9452 14.0899C41.0873 8.23207 33.9642 5.8577 31.0353 8.78663ZM38.1063 15.8577C37.13 16.834 37.9215 19.2084 39.8741 21.161C41.8267 23.1136 44.2011 23.9051 45.1774 22.9288C46.1537 21.9525 45.3622 19.5781 43.4096 17.6255C41.457 15.6728 39.0826 14.8814 38.1063 15.8577Z"
                stroke="#8BAA36"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1031">
                <rect width="60" height="60" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      default:
        break;
    }
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {makePath(size)}
    </svg>
  );
};

export const BananaIcon = ({ size }) => {
  const makePath = size => {
    switch (size) {
      case 33:
        return (
          <>
            <g clipPath="url(#clip0_2212_1140)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.98918 13.5514C11.3285 11.212 14.7534 10.844 16.6388 12.7294C17.1434 13.234 17.4866 13.8489 17.6738 14.5237C16.7814 15.644 15.7707 16.6636 14.6592 17.5646C14.6616 16.5658 14.3283 15.6322 13.6383 14.9422C12.2129 13.5168 9.74779 13.6135 7.82692 15.0619C8.13338 14.5291 8.52196 14.0186 8.98918 13.5514ZM23.903 15.8828L23.8243 15.8797C26.4907 15.8797 28.6522 18.5616 28.6522 21.8699C28.6522 22.2666 28.6211 22.6543 28.5621 23.0287C27.895 20.9987 26.2745 19.566 24.3813 19.566C24.0129 19.566 23.6549 19.6202 23.3122 19.7226C23.0733 19.2753 22.7671 18.8578 22.3935 18.4842L22.48 18.5759C22.9493 17.8791 23.3589 17.1395 23.7018 16.3648L23.903 15.8828ZM23.4715 5.24715C24.2037 5.40911 24.736 6.04256 24.7694 6.79178L24.9089 9.92147C25.0513 13.1154 24.1392 16.1122 22.4806 18.5749L22.3935 18.4842C20.2227 16.3134 16.566 16.4171 14.0479 18.6545L14.2638 18.6567C15.4117 18.689 16.5033 19.1105 17.3282 19.9354C18.0294 20.6366 18.4391 21.5306 18.566 22.488C16.4519 23.9103 13.9321 24.7877 11.2 24.9095C10.7738 24.9285 10.347 24.9285 9.92087 24.9095L6.79118 24.77C5.87665 24.7292 5.16832 23.9548 5.20908 23.0403C5.24247 22.2911 5.77476 21.6576 6.50703 21.4957C13.9929 19.8399 19.8393 13.9935 21.4951 6.50762C21.6928 5.61378 22.5776 5.04945 23.4715 5.24715ZM14.0479 18.6545C16.566 16.4171 20.2227 16.3134 22.3935 18.4842C24.656 20.7467 24.4479 24.6231 21.9286 27.1424C19.8954 29.1757 16.9782 29.7035 14.7388 28.6422C15.4904 28.3455 16.208 27.8832 16.8321 27.2591C18.9915 25.0998 19.2136 21.8208 17.3282 19.9354C16.5033 19.1105 15.4117 18.689 14.2638 18.6567L14.0479 18.6545Z"
                stroke="#8BAA36"
                strokeWidth="1.3"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1140">
                <rect width="33" height="33" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      case 49:
        return (
          <>
            <g clipPath="url(#clip0_2212_1048)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13.3487 20.1216C16.8222 16.648 21.9076 16.1016 24.7072 18.9012C25.4564 19.6504 25.966 20.5634 26.2439 21.5653C24.919 23.2289 23.4182 24.7428 21.7678 26.0806C21.7713 24.5976 21.2764 23.2112 20.2518 22.1867C18.1354 20.0703 14.4751 20.2138 11.6229 22.3645C12.0779 21.5733 12.6549 20.8153 13.3487 20.1216ZM35.4934 23.5833L35.3765 23.5787C39.3357 23.5787 42.5452 27.561 42.5452 32.4734C42.5452 33.0624 42.4991 33.6381 42.4115 34.194C41.421 31.1797 39.0148 29.0523 36.2037 29.0523C35.6567 29.0523 35.125 29.1329 34.6161 29.2849C34.2614 28.6207 33.8068 28.0008 33.2521 27.4461L33.3805 27.5823C34.0774 26.5476 34.6856 25.4494 35.1947 24.2991L35.4934 23.5833ZM34.8527 7.79107C35.94 8.03156 36.7303 8.97215 36.7799 10.0846L36.9871 14.7317C37.1984 19.4743 35.8441 23.924 33.3814 27.5808L33.2521 27.4461C30.0287 24.2227 24.599 24.3767 20.8601 27.6989L21.1807 27.7022C22.8851 27.7502 24.506 28.376 25.7308 29.6009C26.772 30.6421 27.3803 31.9695 27.5688 33.3912C24.4297 35.503 20.6882 36.8059 16.6313 36.9867C15.9986 37.0149 15.3649 37.0149 14.7321 36.9867L10.085 36.7796C8.72703 36.719 7.67526 35.5691 7.73579 34.2112C7.78538 33.0987 8.57574 32.1581 9.66304 31.9177C20.7784 29.4592 29.4595 20.7781 31.918 9.66269C32.2116 8.33547 33.5255 7.49752 34.8527 7.79107ZM20.8601 27.6989C24.599 24.3767 30.0287 24.2227 33.2521 27.4461C36.6116 30.8056 36.3025 36.5615 32.5617 40.3022C29.5427 43.3213 25.2111 44.1051 21.886 42.5291C23.0019 42.0887 24.0675 41.4022 24.9942 40.4755C28.2006 37.2692 28.5303 32.4004 25.7308 29.6009C24.506 28.376 22.8851 27.7502 21.1807 27.7022L20.8601 27.6989Z"
                stroke="#8BAA36"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1048">
                <rect width="49" height="49" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      case 56:
        return (
          <>
            <g clipPath="url(#clip0_2212_1113)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.2548 22.9962C19.2246 19.0264 25.0364 18.402 28.2359 21.6015C29.0922 22.4577 29.6746 23.5011 29.9922 24.6462C28.478 26.5474 26.7628 28.2776 24.8766 29.8065C24.8807 28.1117 24.315 26.5273 23.1441 25.3564C20.7253 22.9376 16.5421 23.1016 13.2825 25.5596C13.8025 24.6554 14.4619 23.7891 15.2548 22.9962ZM40.563 26.9525L40.4295 26.9473C44.9543 26.9473 48.6223 31.4984 48.6223 37.1125C48.6223 37.7857 48.5696 38.4437 48.4694 39.079C47.3374 35.6341 44.5875 33.2028 41.3748 33.2028C40.7497 33.2028 40.142 33.2949 39.5604 33.4685C39.1551 32.7095 38.6355 32.001 38.0016 31.3671L38.1483 31.5227C38.9448 30.3402 39.6398 29.0852 40.2216 27.7706L40.563 26.9525ZM39.8308 8.90422C41.0734 9.17907 41.9767 10.254 42.0334 11.5254L42.2701 16.8364C42.5117 22.2565 40.9639 27.3418 38.1494 31.5211L38.0016 31.3671C34.3177 27.6832 28.1124 27.8593 23.8393 31.6561L24.2056 31.6598C26.1536 31.7147 28.006 32.4299 29.4058 33.8297C30.5957 35.0196 31.291 36.5367 31.5064 38.1615C27.9188 40.575 23.6428 42.064 19.0064 42.2707C18.2832 42.3029 17.559 42.3029 16.8358 42.2707L11.5248 42.0339C9.97291 41.9648 8.77089 40.6506 8.84007 39.0987C8.89674 37.8273 9.80001 36.7523 11.0426 36.4775C23.7459 33.6677 33.6672 23.7465 36.4769 11.0432C36.8124 9.52639 38.314 8.56873 39.8308 8.90422ZM23.8393 31.6561C28.1124 27.8593 34.3177 27.6832 38.0016 31.3671C41.841 35.2065 41.4877 41.7847 37.2126 46.0598C33.7622 49.5102 28.8119 50.4059 25.0118 48.6049C26.2871 48.1015 27.5049 47.317 28.5639 46.2579C32.2284 42.5935 32.6053 37.0292 29.4058 33.8297C28.006 32.4299 26.1536 31.7147 24.2056 31.6598L23.8393 31.6561Z"
                stroke="#8BAA36"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1113">
                <rect width="56" height="56" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      case 60:
        return (
          <>
            <g clipPath="url(#clip0_2212_1043)">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.3444 24.6388C20.5977 20.3854 26.8247 19.7164 30.2528 23.1444C31.1702 24.0618 31.7942 25.1797 32.1345 26.4066C30.5121 28.4436 28.6744 30.2974 26.6535 31.9355C26.6579 30.1196 26.0518 28.422 24.7973 27.1675C22.2057 24.576 17.7237 24.7517 14.2312 27.3852C14.7884 26.4164 15.4949 25.4882 16.3444 24.6388ZM43.4604 28.8777L43.3173 28.872C48.1653 28.872 52.0953 33.7483 52.0953 39.7634C52.0953 40.4847 52.0388 41.1896 51.9315 41.8703C50.7187 38.1793 47.7723 35.5744 44.3302 35.5744C43.6603 35.5744 43.0093 35.673 42.3862 35.8591C41.9518 35.0459 41.3951 34.2868 40.716 33.6076L40.8732 33.7743C41.7265 32.5074 42.4712 31.1627 43.0946 29.7541L43.4604 28.8777ZM42.6758 9.5402C44.0072 9.83468 44.975 10.9864 45.0357 12.3486L45.2894 18.039C45.5482 23.8462 43.8899 29.2948 40.8743 33.7725L40.716 33.6076C36.7689 29.6606 30.1204 29.8492 25.5421 33.9172L25.9346 33.9212C28.0217 33.98 30.0064 34.7463 31.5062 36.2461C32.7811 37.521 33.526 39.1464 33.7568 40.8873C29.913 43.4732 25.3316 45.0685 20.364 45.29C19.5892 45.3245 18.8132 45.3245 18.0384 45.29L12.348 45.0363C10.6853 44.9622 9.39738 43.5542 9.4715 41.8914C9.53222 40.5292 10.5 39.3774 11.8314 39.083C25.4421 36.0725 36.072 25.4426 39.0824 11.832C39.4418 10.2068 41.0507 9.18075 42.6758 9.5402ZM25.5421 33.9172C30.1204 29.8492 36.7689 29.6606 40.716 33.6076C44.8296 37.7212 44.4511 44.7693 39.8706 49.3498C36.1738 53.0466 30.8698 54.0063 26.7983 52.0766C28.1647 51.5372 29.4695 50.6967 30.6042 49.562C34.5304 45.6358 34.9342 39.6741 31.5062 36.2461C30.0064 34.7463 28.0217 33.98 25.9346 33.9212L25.5421 33.9172Z"
                stroke="#8BAA36"
                strokeWidth="2"
                strokeLinecap="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_2212_1043">
                <rect width="60" height="60" fill="white" />
              </clipPath>
            </defs>
          </>
        );
      default:
        break;
    }
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {makePath(size)}
    </svg>
  );
};

export const OrangeIcon = ({ size }) => {
  const makePath = size => {
    switch (size) {
      case 33:
        return (
          <path
            d="M13.75 8.25C19.0657 8.25 23.375 12.5593 23.375 17.875C23.375 18.3901 23.3345 18.8957 23.2566 19.3888L18.8591 14.9927C17.4015 16.4503 16.5 18.464 16.5 20.6882C16.5 22.802 17.3143 24.7256 18.6462 26.1625C17.2122 27.0124 15.5381 27.5 13.75 27.5C8.43426 27.5 4.125 23.1907 4.125 17.875C4.125 12.5593 8.43426 8.25 13.75 8.25ZM13.75 8.25L10.191 7.5382C8.2629 7.15258 6.875 5.45962 6.875 3.49331V2.75L10.434 3.4618C12.3621 3.84742 13.75 5.54038 13.75 7.50669V9.625M13.75 8.25V9.625M13.75 9.625C13.75 7.93962 14.7022 6.39889 16.2097 5.64516L16.5 5.5M20.6116 16.8774L20.5408 16.8067C20.0153 16.2812 19.4547 15.7206 18.8591 15.125C17.4015 16.5826 16.5 18.5962 16.5 20.8204C16.5 21.3583 16.5527 21.8838 16.6533 22.3921C16.7569 22.916 16.9113 23.4215 17.1111 23.9035C17.5194 24.888 18.1172 25.774 18.8591 26.5159C19.601 27.2578 20.487 27.8556 21.4715 28.2639C21.9535 28.4637 22.459 28.6181 22.9829 28.7217C23.4912 28.8223 24.0167 28.875 24.5546 28.875C26.7788 28.875 28.7924 27.9735 30.25 26.5159C29.6544 25.9203 29.0938 25.3597 28.5683 24.8342L28.4976 24.7634M20.6116 16.8774C19.6025 17.8865 18.9783 19.2806 18.9783 20.8204M20.6116 16.8774L20.9284 17.1943C21.0554 17.3213 21.1802 17.4461 21.3028 17.5687L22.0123 18.2782C22.1262 18.392 22.2378 18.5037 22.3473 18.6132L23.8254 20.0913C24.0882 20.354 24.3312 20.5971 24.5546 20.8204M18.9783 20.8204C18.9783 23.9001 21.4749 26.3967 24.5546 26.3967M18.9783 20.8204C18.9783 21.1928 19.0148 21.5566 19.0844 21.9085L24.5546 20.8204M24.5546 26.3967C26.0944 26.3967 27.4885 25.7725 28.4976 24.7634M24.5546 26.3967C23.7984 26.3967 23.0773 26.2462 22.4198 25.9734L24.5546 20.8204M28.4976 24.7634L28.1807 24.4466C28.0537 24.3196 27.9289 24.1948 27.8063 24.0722L27.0968 23.3627C26.983 23.2488 26.8713 23.1372 26.7618 23.0277L25.2837 21.5496C25.021 21.2868 24.7779 21.0438 24.5546 20.8204"
            stroke="#8BAA36"
            strokeWidth="1.3"
            strokeLinecap="round"
          />
        );
      case 49:
        return (
          <path
            d="M20.4167 12.2499C28.3097 12.2499 34.7083 18.6485 34.7083 26.5416C34.7083 27.3064 34.6483 28.0571 34.5326 28.7894L28.0029 22.2619C25.8386 24.4262 24.5 27.4161 24.5 30.7187C24.5 33.8574 25.709 36.7137 27.6868 38.8472C25.5576 40.1093 23.0717 40.8333 20.4167 40.8333C12.5236 40.8333 6.125 34.4347 6.125 26.5416C6.125 18.6485 12.5236 12.2499 20.4167 12.2499ZM20.4167 12.2499L15.1321 11.193C12.2691 10.6204 10.2083 8.10662 10.2083 5.18695V4.08325L15.4929 5.14016C18.3559 5.71276 20.4167 8.22655 20.4167 11.1462V14.2916M20.4167 12.2499V14.2916M20.4167 14.2916C20.4167 11.789 21.8306 9.5013 24.0689 8.38213L24.5 8.16659M30.6051 25.0604L30.5 24.9553C29.7197 24.175 28.8873 23.3426 28.0029 22.4583C25.8386 24.6226 24.5 27.6125 24.5 30.9151C24.5 31.7137 24.5783 32.4941 24.7276 33.2489C24.8814 34.0267 25.1107 34.7773 25.4074 35.493C26.0136 36.9548 26.9013 38.2703 28.0029 39.372C29.1046 40.4736 30.4201 41.3613 31.8819 41.9675C32.5976 42.2642 33.3483 42.4935 34.1261 42.6473C34.8809 42.7966 35.6612 42.8749 36.4598 42.8749C39.7624 42.8749 42.7524 41.5363 44.9167 39.372C44.0323 38.4876 43.1999 37.6552 42.4196 36.8749L42.3146 36.7699M30.6051 25.0604C29.1067 26.5587 28.1799 28.6287 28.1799 30.9151M30.6051 25.0604L31.0755 25.5308C31.2641 25.7194 31.4494 25.9047 31.6315 26.0868L32.6849 27.1403C32.854 27.3093 33.0198 27.4751 33.1824 27.6377L35.3771 29.8324C35.7673 30.2226 36.1282 30.5835 36.4598 30.9151M28.1799 30.9151C28.1799 35.488 31.887 39.195 36.4598 39.195M28.1799 30.9151C28.1799 31.468 28.2341 32.0082 28.3375 32.5307L36.4598 30.9151M36.4598 39.195C38.7462 39.195 40.8162 38.2682 42.3146 36.7699M36.4598 39.195C35.337 39.195 34.2664 38.9715 33.29 38.5665L36.4598 30.9151M42.3146 36.7699L41.8441 36.2994C41.6555 36.1108 41.4702 35.9255 41.2881 35.7434L40.2347 34.69C40.0656 34.5209 39.8998 34.3551 39.7372 34.1925L37.5425 31.9978C37.1524 31.6077 36.7914 31.2468 36.4598 30.9151"
            stroke="#8BAA36"
            strokeWidth="2"
            strokeLinecap="round"
          />
        );
      case 56:
        return (
          <path
            d="M23.3333 14.0001C32.354 14.0001 39.6667 21.3128 39.6667 30.3334C39.6667 31.2075 39.598 32.0655 39.4658 32.9023L32.0034 25.4423C29.5299 27.9158 28 31.3329 28 35.1073C28 38.6943 29.3818 41.9586 31.6421 44.397C29.2087 45.8393 26.3676 46.6667 23.3333 46.6667C14.3127 46.6667 7 39.3541 7 30.3334C7 21.3128 14.3127 14.0001 23.3333 14.0001ZM23.3333 14.0001L17.2939 12.7922C14.0219 12.1378 11.6667 9.26489 11.6667 5.92812V4.66675L17.7061 5.87464C20.9781 6.52904 23.3333 9.40194 23.3333 12.7387V16.3334M23.3333 14.0001V16.3334M23.3333 16.3334C23.3333 13.4734 24.9492 10.8588 27.5073 9.57975L28 9.33341M34.9772 28.6406L34.8572 28.5205C33.9653 27.6287 33.0141 26.6775 32.0034 25.6667C29.5299 28.1402 28 31.5573 28 35.3317C28 36.2444 28.0895 37.1362 28.2601 37.9989C28.4359 38.8878 28.6979 39.7457 29.0371 40.5636C29.7298 42.2342 30.7444 43.7377 32.0034 44.9967C33.2624 46.2557 34.7659 47.2703 36.4365 47.963C37.2544 48.3022 38.1123 48.5642 39.0012 48.74C39.8638 48.9106 40.7556 49.0001 41.6683 49.0001C45.4428 49.0001 48.8598 47.4702 51.3333 44.9967C50.3226 43.986 49.3714 43.0347 48.4795 42.1429L48.3595 42.0229M34.9772 28.6406C33.2648 30.353 32.2056 32.7187 32.2056 35.3317M34.9772 28.6406L35.5149 29.1782C35.7304 29.3938 35.9422 29.6056 36.1503 29.8137L37.3542 31.0176C37.5474 31.2108 37.737 31.4003 37.9227 31.5861L40.431 34.0943C40.8769 34.5403 41.2893 34.9527 41.6683 35.3317M32.2056 35.3317C32.2056 40.5578 36.4422 44.7944 41.6683 44.7944M32.2056 35.3317C32.2056 35.9636 32.2676 36.5809 32.3857 37.1781L41.6683 35.3317M41.6683 44.7944C44.2814 44.7944 46.6471 43.7353 48.3595 42.0229M41.6683 44.7944C40.3851 44.7944 39.1616 44.539 38.0457 44.0762L41.6683 35.3317M48.3595 42.0229L47.8218 41.4852C47.6063 41.2697 47.3945 41.0579 47.1864 40.8498L45.9825 39.6459C45.7893 39.4526 45.5997 39.2631 45.4139 39.0773L42.9057 36.5691C42.4598 36.1232 42.0474 35.7107 41.6683 35.3317"
            stroke="#8BAA36"
            strokeWidth="2"
            strokeLinecap="round"
          />
        );
      case 60:
        return (
          <path
            d="M25 15C34.665 15 42.5 22.835 42.5 32.5C42.5 33.4365 42.4264 34.3558 42.2848 35.2524L34.2893 27.2595C31.6392 29.9097 30 33.5708 30 37.6149C30 41.4581 31.4805 44.9556 33.9022 47.5681C31.295 49.1135 28.251 50 25 50C15.335 50 7.5 42.165 7.5 32.5C7.5 22.835 15.335 15 25 15ZM25 15L18.5291 13.7058C15.0234 13.0047 12.5 9.92658 12.5 6.35147V5L18.9709 6.29417C22.4766 6.99531 25 10.0734 25 13.6485V17.5M25 15V17.5M25 17.5C25 14.4357 26.7313 11.6343 29.4721 10.2639L30 10M37.4756 30.6863L37.347 30.5576C36.3914 29.6021 35.3722 28.5829 34.2893 27.5C31.6392 30.1502 30 33.8113 30 37.8553C30 38.8332 30.0958 39.7887 30.2787 40.713C30.467 41.6654 30.7478 42.5846 31.1111 43.4609C31.8534 45.2509 32.9404 46.8617 34.2893 48.2107C35.6383 49.5596 37.2491 50.6466 39.0391 51.3889C39.9154 51.7522 40.8346 52.033 41.787 52.2213C42.7113 52.4042 43.6668 52.5 44.6447 52.5C48.6887 52.5 52.3498 50.8608 55 48.2107C53.9171 47.1278 52.8979 46.1086 51.9424 45.153L51.8137 45.0244M37.4756 30.6863C35.6409 32.521 34.506 35.0556 34.506 37.8553M37.4756 30.6863L38.0516 31.2623C38.2826 31.4932 38.5095 31.7202 38.7324 31.9431L40.0224 33.2331C40.2294 33.4401 40.4325 33.6431 40.6315 33.8422L43.3189 36.5296C43.7966 37.0073 44.2386 37.4492 44.6447 37.8553M34.506 37.8553C34.506 43.4547 39.0453 47.994 44.6447 47.994M34.506 37.8553C34.506 38.5323 34.5724 39.1938 34.6989 39.8336L44.6447 37.8553M44.6447 47.994C47.4444 47.994 49.979 46.8591 51.8137 45.0244M44.6447 47.994C43.2698 47.994 41.9588 47.7203 40.7633 47.2244L44.6447 37.8553M51.8137 45.0244L51.2377 44.4484C51.0068 44.2174 50.7798 43.9905 50.5569 43.7676L49.2669 42.4776C49.0599 42.2706 48.8569 42.0675 48.6578 41.8685L45.9704 39.1811C45.4927 38.7034 45.0508 38.2614 44.6447 37.8553"
            stroke="#8BAA36"
            strokeWidth="2"
            strokeLinecap="round"
          />
        );
      default:
        break;
    }
  };
  return (
    <svg
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {makePath(size)}
    </svg>
  );
};

export const MainIcon = ({ mobile }) => {
  const iconSize = mobile ? 40 : 44;
  const makePath = iconSize => {
    switch (iconSize) {
      case 40:
        return (
          <>
            <rect width="40" height="40" rx="12" fill="#8BAA36" />
            <path
              d="M8.79883 8.89569V13.9857V14.0884V13.9857C8.79883 15.4391 9.43295 16.7258 10.4161 17.5586C10.8969 17.9658 11.2145 18.5157 11.2145 19.126V27.6223C11.2145 28.5669 12.0262 29.3334 13.0263 29.3334C14.0264 29.3334 14.838 28.5669 14.838 27.6223V19.126C14.838 18.5157 15.1557 17.9658 15.6364 17.5586C16.6196 16.7258 17.2537 15.4391 17.2537 13.9857V8.89569V13.9857"
              stroke="#FAFAFA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M13.0254 14.5038V8.79999"
              stroke="#FAFAFA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M29.3322 9.99976C29.3322 9.37007 28.7911 8.85901 28.1243 8.85901H26.9165C24.9151 8.85901 23.293 10.391 23.293 12.2813V19.1258C23.293 20.6133 24.3039 21.867 25.7087 22.3382V27.6221C25.7087 28.5667 26.5203 29.3333 27.5204 29.3333C28.5205 29.3333 29.3322 28.5667 29.3322 27.6221V22.5481V9.99976Z"
              stroke="#FAFAFA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      case 44:
        return (
          <>
            <rect width="44" height="44" rx="12" fill="#8BAA36" />
            <path
              d="M10 10.1025V15.5561V15.6661V15.5561C10 17.1132 10.6794 18.4919 11.7328 19.3841C12.2479 19.8205 12.5882 20.4096 12.5882 21.0635V30.1667C12.5882 31.1787 13.4579 32.0001 14.5294 32.0001C15.6009 32.0001 16.4706 31.1787 16.4706 30.1667V21.0635C16.4706 20.4096 16.8109 19.8205 17.326 19.3841C18.3794 18.4919 19.0588 17.1132 19.0588 15.5561V10.1025V15.5561"
              stroke="#FAFAFA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5293 16.1112V10"
              stroke="#FAFAFA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M31.9999 11.2854C31.9999 10.6107 31.4201 10.0632 30.7058 10.0632H29.4116C27.2673 10.0632 25.5293 11.7046 25.5293 13.7299V21.0633C25.5293 22.6571 26.6125 24.0003 28.1175 24.5051V30.1665C28.1175 31.1785 28.9872 31.9999 30.0587 31.9999C31.1302 31.9999 31.9999 31.1785 31.9999 30.1665V24.73V11.2854Z"
              stroke="#FAFAFA"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      default:
        break;
    }
  };
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox={`0 0 ${iconSize} ${iconSize}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {makePath(iconSize)}
    </svg>
  );
};

export const FooterIcon = ({ mobile }) => {
  const iconSize = mobile ? 32 : 44;
  const makePath = iconSize => {
    switch (iconSize) {
      case 32:
        return (
          <>
            <rect width="32" height="32" rx="6" fill="#EBF3D4" />
            <path
              d="M7 7.08398V11.546V11.636V11.546C7 12.8201 7.55588 13.9481 8.41776 14.6781C8.83918 15.0351 9.11765 15.5171 9.11765 16.0521V23.5002C9.11765 24.3282 9.82918 25.0002 10.7059 25.0002C11.5826 25.0002 12.2941 24.3282 12.2941 23.5002V16.0521C12.2941 15.5171 12.5726 15.0351 12.994 14.6781C13.8559 13.9481 14.4118 12.8201 14.4118 11.546V7.08398V11.546"
              stroke="#8BAA36"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M10.7051 12.0001V7"
              stroke="#8BAA36"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M24.9992 8.05177C24.9992 7.49976 24.5248 7.05176 23.9404 7.05176H22.8815C21.1271 7.05176 19.7051 8.39477 19.7051 10.0518V16.0519C19.7051 17.3559 20.5913 18.4549 21.8227 18.8679V23.5C21.8227 24.328 22.5343 25 23.411 25C24.2877 25 24.9992 24.328 24.9992 23.5V19.0519V8.05177Z"
              stroke="#8BAA36"
              strokeWidth="1.8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      case 44:
        return (
          <>
            <rect width="44" height="44" rx="12" fill="#EBF3D4" />
            <path
              d="M10 10.1025V15.5562V15.6662V15.5562C10 17.1133 10.6794 18.492 11.7328 19.3842C12.2479 19.8205 12.5882 20.4097 12.5882 21.0636V30.1668C12.5882 31.1788 13.4579 32.0001 14.5294 32.0001C15.6009 32.0001 16.4706 31.1788 16.4706 30.1668V21.0636C16.4706 20.4097 16.8109 19.8205 17.326 19.3842C18.3794 18.492 19.0588 17.1133 19.0588 15.5562V10.1025V15.5562"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M14.5293 16.1112V10"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M31.9999 11.2857C31.9999 10.611 31.4201 10.0635 30.7058 10.0635H29.4116C27.2673 10.0635 25.5293 11.7049 25.5293 13.7302V21.0636C25.5293 22.6574 26.6125 24.0006 28.1175 24.5054V30.1668C28.1175 31.1788 28.9872 32.0002 30.0587 32.0002C31.1302 32.0002 31.9999 31.1788 31.9999 30.1668V24.7303V11.2857Z"
              stroke="#8BAA36"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </>
        );
      default:
        break;
    }
  };
  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox={`0 0 ${iconSize} ${iconSize}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {makePath(iconSize)}
    </svg>
  );
};
